const value = {
    writeUs: 'Напишите нам',
    orCall: 'Или позвоните',
  };

export default value;
